import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import React from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import HowItWorksAndChoosePlanSection
  from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';

const WinDisneylandParisTickets = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-disneyland-paris-tickets`;

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win Day Tickets To Disneyland Paris"
        description="Enter our weekly draw for the chance to win 3 tickets to meet Mickey at Disneyland Paris"
        url="https://www.daymade.co.uk/prizes/details/disneyland-paris-day-tickets"
        openGraph={{
          title: 'DAYMADE | Win Day Tickets To Disneyland Paris',
          description: 'Enter our weekly draw for the chance to win 3 tickets to meet Mickey at Disneyland Paris',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="Sleeping Beauty Castle in Disneyland Paris theme park"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer'>
          <Subheading Tag='h1' className='pageTitle'>
            Win Day Tickets To<br />
            <span style={{ fontSize: '1.5em', display: 'block' }}>
              Disneyland&nbsp;<strong>Paris</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win 3 tickets to meet Mickey at Disneyland Paris
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing various attractions is Disneyland Paris, such as Spiderman and Mickey Mouse"
        >
          <p>
            Disneyland Paris is where dreams really do come true. And what better way to experience all things Disneyland than with their 30th Anniversary? Bigger dreams, louder laughs and wider smiles all round. Disneyland Paris is both a classic and a dreamy wonderland. Discover Disneyland Paris’ magic with Day Tickets for three people! Your tickets will be undated, meaning you can pre-book your dates at a time that suits you, gaining access to either Disneyland or Walt Disney Studios.
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="lady holding up Minnie Mouse headband with castle in background"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>
              Three 1-Day Undated Disneyland Paris tickets
            </li>
          </ul>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>
    </MainLayout>
  );
};

export default WinDisneylandParisTickets;
